define('previewPopover',['jquery', 'underscore'], function ($, _) {
  'use strict';

  var DEFAULTS = {
    placement: 'right',
    container: 'body',
    maxWidth: 260,
    maxHeight: 300,
    zIndex: 100000,
    namespace: 'previewPopover'
  };

  function attach($target, url, options) {
    if (!$target || !$target.length || !url) {
      return;
    }
    var opts = _.extend({}, DEFAULTS, options || {});

    $target.attr('src', url);
    $target.attr('data-link', url);

    if ($target.data('bs.popover')) {
      $target.popover('destroy');
    }

    var content = '<div class="img-responsive"><img class="img-popover" src="' + url +
      '" style="display:block;max-width:' + opts.maxWidth + 'px;max-height:' + opts.maxHeight +
      'px;width:auto;height:auto;border-radius:6px;"/></div>';
    $target.attr('data-content', content);

    var popover = $target.popover({
      trigger: 'hover',
      placement: opts.placement,
      html: true,
      container: opts.container
    }).data('bs.popover');

    if (popover) {
      popover.tip().addClass('jqgrid-popover');
    }

    var ev = 'shown.bs.popover.' + opts.namespace;
    $target.off(ev).on(ev, function () {
      var pop = $(this).data('bs.popover');
      if (!pop) return;
      var $tip = pop.tip();
      $tip.css('z-index', opts.zIndex);
      $tip.css('max-width', 'none');
      $tip.find('.popover-content').css('padding', '8px');

      var tipRect = $tip[0].getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var pad = 10;
      if (tipRect.bottom > vh - pad) {
        var currentTop = parseFloat($tip.css('top')) || 0;
        $tip.css('top', (currentTop - (tipRect.bottom - vh + pad)) + 'px');
      } else if (tipRect.top < pad) {
        var currentTop2 = parseFloat($tip.css('top')) || 0;
        $tip.css('top', (currentTop2 + (pad - tipRect.top)) + 'px');
      }
    });
  }

  function detach($target) {
    if ($target && $target.length && $target.data('bs.popover')) {
      $target.popover('destroy');
    }
  }

  return {
    attach: attach,
    detach: detach
  };
});

